import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readReceiptTypeSelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 수금예정월 셀렉트박스
 * @param props
 * @returns
 */
export const useReadReceiptTypeSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readReceiptTypeSelect"],
        queryFn: async () => await readReceiptTypeSelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
